import {CustomCode} from "../../../model/common.model";

export class TypeOfApproval extends CustomCode{
  public static _registered = new Map<string, TypeOfApproval>();
  static AVAILABILITIES_SE = new TypeOfApproval('AVAILABILITIES_SE');
  static AVAILABILITIES_PERIODIC = new TypeOfApproval('AVAILABILITIES_PERIODIC');
  static ALL = Array.from(TypeOfApproval._registered.values());


  constructor (code: string) {
    super(code);
    TypeOfApproval._registered.set(code, this);
  }

  public toTranslateKey(): string{
    return 'TYPE_APROVAL_' + this.code;
  }

  static retrieveFromCode(code: string): TypeOfApproval {
    const res = TypeOfApproval._registered.get(code);
    if (!res) {
      console.log('TypeOfApproval can\'t be found with code: ' + code);
      return null;
    }
    return res;
  }

}
